import {
    FacebookFilled,
    InfoCircleOutlined,
    InstagramFilled,
    QuestionCircleOutlined,
} from '@ant-design/icons';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import smilingLogo from '../../assets/images/kdetosakraSmile.svg';
import { routeNames } from '../../constants/routes';

const Menu = ({ isInGame = false }) => {
    const { pathname } = useLocation();
    const currentBattleInfo = useSelector(state => state.battle.currentBattle);

    const isBattle = pathname.includes(routeNames.battle) && currentBattleInfo?.battleId;

    const menuItemWithIconContainerStyles = isBattle || isInGame ? 'menu-item-with-icon-container' : '';

    const menuContent = (
        <>
            <Link to="/">
                <div className="logo">
                    <img
                        id="kdetosakra-logo"
                        src={smilingLogo}
                        alt="logo"
                        className="kdetosakra-logo"
                        width="30px"
                        height="auto"
                    />
                    <h2 className="kdetosakra-logo-text">Kde to sakra?</h2>
                </div>
            </Link>
            <div className={isBattle || isInGame ? 'main-menu--battle' : 'main-menu'}>
                <div className={menuItemWithIconContainerStyles}>
                    <Link to={`/${routeNames.info}`}>
                        <InfoCircleOutlined className={classNames('menu-item-icon')} />
                        <div className="menu-item">O hře</div>
                    </Link>
                </div>
                <div className="menu-item menu-separator">|</div>
                <div className={menuItemWithIconContainerStyles}>
                    <Link to={`/${routeNames.napoveda}`}>
                        <QuestionCircleOutlined className="menu-item-icon" />
                        <div className="menu-item">Jak to hrát?</div>
                    </Link>
                </div>
                {!isInGame && (
                    <>
                        <div className="menu-item menu-separator">|</div>
                        {/* eslint-disable-next-line react/jsx-no-target-blank */}
                        <div className={menuItemWithIconContainerStyles}>
                            <a
                                title="Facebook stránka"
                                href="https://www.facebook.com/kdetosakra.cz"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <FacebookFilled style={{ color: 'rgb(66, 103, 178)', fontSize: '25px' }} />
                            </a>
                        </div>
                        <div className="menu-item menu-separator">|</div>
                        {/* eslint-disable-next-line react/jsx-no-target-blank */}
                        <div className={menuItemWithIconContainerStyles}>
                            <a
                                title="Instagram stránka"
                                href="https://www.instagram.com/kdetosakra/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <InstagramFilled style={{ color: 'rgb(126,125,125)', fontSize: '25px' }} />
                            </a>
                        </div>
                    </>
                )}
            </div>
        </>
    );

    return (
        <div id="menu-container" className={classNames('section menu-container', isInGame && 'menu-without-padding')}>
            {isInGame ? (
                menuContent
            ) : (
                <div className="menu-content-wrapper">
                    {menuContent}
                </div>
            )}
        </div>
    );
};

export default Menu;
